import { createContext } from 'react'
import { Nullable } from 'types/nullable'

interface ToastMethods {
  success(message: string): void
  error(message: string): void
}

export const ToastContext = createContext<Nullable<ToastMethods>>(null)
